export default "__VITE_ASSET__B1XHqvV0__"